{
  "account": {
    "title": "Tài khoản của tôi",
    "list": {
      "title": "Tài khoản",
      "description": "Danh sách hóa đơn đã kết nối tới tài khoản"
    },
    "form": {
      "name": {
        "title": "Tên",
        "description": "Tên tài khoản"
      },
      "password": {
        "title": "Mật khẩu",
        "description": "Đặt mật khẩu mới cho tài khoản của bạn, để trống để giữ mật khẩu hiện tại"
      },
      "emailPreferences": {
        "title": "Tùy chọn thư điện tử",
        "description": "Chọn các loại thông báo qua thư điện tử"
      }
    },
    "billing": "Thông tin hóa đơn",
    "subscriptions": "Quản lý đăng ký",
    "manageSubscription": "Quản lý đăng ký",
    "popup": {
      "downgrade": "Bạn có chắc chắn hạ cấp không? Việc hạ cấp sẽ có hiệu lực ngay lập tức. <br/> Vui lòng lưu ý rằng bạn sẽ không đủ điều kiện để được giảm giá trong thời gian còn lại của chu kỳ thanh toán hiện tại. <br/> Giá gói mới sẽ được áp dụng vào chu kỳ thanh toán tiếp theo.",
      "default": "Bạn có chắc chắn muốn thay đổi kế hoạch của mình không?",
      "cancel": "Bạn có chắc chắn hủy đăng ký của mình không?<br/> Trang web của bạn sẽ tiếp tục được dịch cho đến khi kết thúc thời gian đăng ký hiện tại của bạn. Sau đó, bản dịch sẽ bị vô hiệu hóa.<br/> Xin vui lòng lưu ý rằng bạn sẽ không đủ điều kiện được giảm giá cho khoảng thời gian chưa sử dụng.",
      "resume": "Bạn có chắc chắn muốn tiếp tục đăng ký không?"
    }
  },
  "ai_translation": {
    "header": "Bản dịch AI",
    "plan": {
      "header": "Bảng giá dịch thuật AI",
      "used": "Bạn đã sử dụng {words_used} / {words_allowed} từ đã dịch trong phần ghi công AI của mình.",
      "remaining": "Tín chỉ AI có sẵn:",
      "words": "từ",
      "add_more_credits": "Thêm nhiều tín chỉ AI hơn",
      "details": {
        "idiomatic_expressions": "Thành ngữ và cách diễn đạt kỹ thuật",
        "background_translation": "Bản dịch trong nền",
        "page_context": "Bối cảnh trang và trang web để dịch",
        "perfect_quality": "Chất lượng hoàn hảo, giá cả phải chăng",
        "no_recurring": "Không thanh toán định kỳ, hạn ngạch trả trước",
        "save_40": "Tiết kiệm 40% so với gói 20 đô la",
        "save_50": "Tiết kiệm 50% so với gói 20 đô la",
        "best_website": "Trang web yêu cầu chất lượng dịch thuật hoàn hảo"
      },
      "quota": "{estimated_words} từ ~ {estimated_pages} trang"
    },
    "settings": {
      "banner": {
        "title": "Bản dịch AI của Linguise",
        "intro": "Linguise hân hạnh giới thiệu Linguise AI Translation, một tính năng cao cấp mới tận dụng các mô hình AI LLM (các mô hình Llama mới nhất, được tối ưu hóa cho các tác vụ dịch thuật). Được thiết kế cho các trang web đòi hỏi độ chính xác tuyệt đối, tính năng này xem xét cả ngữ cảnh của trang và toàn bộ trang web để mang lại kết quả vượt trội. Mang đến cho khách hàng chất lượng dịch thuật đỉnh cao, đảm bảo thông điệp của họ được truyền tải hoàn hảo trong mọi ngôn ngữ.",
        "button": "Nâng cấp ngay"
      },
      "alert": {
        "description": "Tính năng này không có trong gói hiện tại của bạn và yêu cầu mua riêng. Kích hoạt tiện ích bổ sung này để mở khóa tất cả các tùy chọn được liệt kê bên dưới."
      },
      "languages": {
        "title": "Áp dụng dịch thuật AI vào ngôn ngữ",
        "description": "Chọn ngôn ngữ cụ thể mà bạn muốn áp dụng bản dịch AI"
      },
      "button": {
        "save": "Lưu cài đặt"
      },
      "form": {
        "rule_application": {
          "description": "Áp dụng Bản dịch AI trên nội dung tĩnh hoặc nội dung động hoặc cả hai",
          "title": "Áp dụng cho nội dung",
          "all": "Tất cả nội dung",
          "static": "Nội dung tĩnh",
          "dynamic": "Nội dung động"
        },
        "website_topic": {
          "title": "Chủ đề trang web",
          "placeholder": "Nhà hàng sushi...",
          "description": "Xác định chủ đề của trang web để có chất lượng dịch tốt hơn (ví dụ: Pháp lý, nhà hàng sushi, cửa hàng phụ tùng xe đạp trực tuyến…).\nVui lòng nhập chủ đề của trang web bằng tiếng Anh."
        },
        "apply_to_urls": {
          "title": "Áp dụng cho URL",
          "description": "Chọn các URL cụ thể mà bạn muốn áp dụng bản dịch AI",
          "all_urls": "Tất cả các URL",
          "selected_urls": "URL đã chọn",
          "label": "Url để áp dụng",
          "placeholder": "Url để áp dụng",
          "wildcard": "Ký tự đại diện",
          "regex": "Biểu thức chính quy",
          "add": "Thêm mới",
          "expression": "Kiểu biểu thức"
        },
        "apply_languages": {
          "title": "Áp dụng cho các ngôn ngữ",
          "description": "Chọn ngôn ngữ cụ thể mà bạn muốn áp dụng bản dịch AI",
          "all_languages": "Tất cả các ngôn ngữ",
          "selected_languages": "Ngôn ngữ đã chọn",
          "placeholder": "Chọn ngôn ngữ...",
          "feedback": "Bạn phải chọn một ngôn ngữ"
        },
        "enable_mode": {
          "title": "BẬT DỊCH AI",
          "description": "Chọn cách bạn muốn bật tính năng dịch AI.\nChỉ áp dụng các quy tắc sau đây.\nChỉ trình chỉnh sửa trực tiếp mới cho phép bật tính năng dịch từng trang từ chế độ xem trình chỉnh sửa trực tiếp.\nQuy tắc và trình chỉnh sửa trực tiếp sẽ sử dụng cả hai tính năng.",
          "disabled": "Tàn tật",
          "rules": "Chỉ có quy tắc",
          "live_editor": "Chỉ biên tập trực tiếp",
          "all": "Quy tắc và biên tập viên trực tiếp"
        },
        "formality": {
          "title": "Tính trang trọng",
          "description": "Chỉ rõ mức độ trang trọng trong bản dịch, có thể quan trọng đối với đối tượng độc giả và bối cảnh. \"Trung tính\" sẽ cố gắng giữ nguyên tính trang trọng của nội dung gốc. \"Trang trọng\" dành cho nội dung chuyên môn, kinh doanh hoặc pháp lý (ví dụ: sử dụng đại từ trang trọng như \"usted\" trong tiếng Tây Ban Nha). \"Không trang trọng\" dành cho nội dung giao tiếp thông thường (ví dụ: sử dụng \"tú\" trong tiếng Tây Ban Nha).",
          "neutral": "Trung lập",
          "formal": "Chính thức",
          "informal": "Không chính thức"
        },
        "sentence_structure": {
          "classic": "Cổ điển",
          "short": "Câu ngắn gọn và súc tích",
          "detailed": "Câu chi tiết và giải thích",
          "title": "Cấu trúc câu",
          "description": "Xác định phong cách viết ưa thích."
        },
        "content_purpose": {
          "marketing": "Tiếp thị/quảng cáo (giọng điệu thuyết phục, hấp dẫn)",
          "technical": "Kỹ thuật/hướng dẫn (rõ ràng, chính xác, hướng tới hành động)",
          "support": "Hỗ trợ khách hàng (đồng cảm, hữu ích, trấn an)",
          "legal": "Pháp lý/tuân thủ (chính xác, trang trọng, rõ ràng)",
          "educational": "Giáo dục (rõ ràng, có cấu trúc, dễ hiểu)",
          "title": "Mục đích nội dung",
          "description": "Xác định mục đích chức năng của nội dung đang được dịch.",
          "other_placeholder": "Mô tả mục đích...",
          "other": "Khác (Bằng tiếng Anh)"
        },
        "target_audience": {
          "title": "Đối tượng mục tiêu",
          "description": "Xác định đối tượng mục tiêu của nội dung được dịch (bằng tiếng Anh).",
          "placeholder": "ví dụ: phụ huynh nói tiếng Tây Ban Nha, cán bộ bảo mật thông tin của EU"
        },
        "advanced": {
          "title": "Hướng dẫn AI nâng cao",
          "description": "Hướng dẫn AI nâng cao"
        },
        "override_default_translations": {
          "title": "Ghi đè bản dịch mặc định",
          "description": "Nếu đặt thành CÓ, tùy chọn này sẽ buộc nội dung phải được dịch bằng AI (Linguise AI) ngay cả khi nội dung đó đã được dịch bằng dịch thuật Cloud AI (mô hình dịch thuật mặc định)."
        },
        "force_replace_before": {
          "title": "Buộc dịch lại bằng AI",
          "description": "Dịch lại bằng AI mọi nội dung có bản dịch AI được tạo trước ngày đã chọn, chẳng hạn nội dung được dịch bằng mô hình cũ hơn. Việc dịch lại diễn ra vào lần truy cập tiếp theo vào các trang áp dụng theo Quy tắc và sử dụng tín dụng AI của bạn.",
          "before_date": "Trước một ngày"
        },
        "model": {
          "current": "Hiện tại",
          "title": "Mô hình",
          "description": "Chọn mô hình dịch thuật LLM bạn muốn sử dụng",
          "load_error": "Không thể tải các mô hình có sẵn. Vui lòng thử lại sau.",
          "thinking_warning": "Mô hình này sử dụng mức độ suy luận cao (\"tư duy\") và sẽ tiêu thụ nhiều token hơn đáng kể cho mỗi bản dịch."
        },
        "override_manual_and_selected": {
          "no_default": "Không (mặc định)",
          "title": "Ghi đè bản dịch thủ công và bản dịch đã chọn",
          "description": "Theo mặc định, bản dịch bạn đã chỉnh sửa thủ công luôn được giữ trên website, kể cả khi bản dịch AI nâng cao đã được tạo. Đặt thành CÓ để hiển thị bản dịch AI nâng cao thay thế. Bản dịch thủ công của bạn vẫn được giữ lại và bạn có thể chuyển lại bất cứ lúc nào. Điều này cũng áp dụng khi bạn dịch lại các trang để có bản dịch mới; bản dịch mới nhất sẽ được tự động sử dụng."
        }
      },
      "message": {
        "save_success": "Từ nội dung hiện đã được dịch, số trang sẽ được cải thiện bằng công nghệ dịch AI là khoảng {{ai_affected_urls}}.",
        "save_success_only": "Cài đặt đã được lưu thành công."
      }
    },
    "pricing": {
      "plan": {
        "title": "Đặt hạn ngạch dịch thuật AI",
        "buy_button": "MUA GÓI DỊCH THUẬT AI"
      },
      "modal": {
        "title": "Xác nhận thay đổi kế hoạch",
        "description": "Bạn có chắc chắn muốn thay đổi gói dịch thuật AI của mình không?",
        "button_cancel": "Hủy bỏ",
        "button_confirm": "Xác nhận",
        "loading": "Vui lòng chờ...",
        "amount": "Số lượng",
        "credit": "Tín dụng",
        "total_due": "Tổng số tiền phải trả"
      },
      "comparison": {
        "title": "Bản dịch AI của Google Cloud so với bản dịch AI của Linguise",
        "list": {
          "0": {
            "google": "Bản dịch nhanh chóng và đáng tin cậy",
            "linguise": "Xử lý các thành ngữ và cách diễn đạt kỹ thuật"
          },
          "1": {
            "google": "Bản dịch tức thời của tất cả các trang web",
            "linguise": "Tạo bản dịch trong nền"
          },
          "2": {
            "google": "Chất lượng tốt nhất, giá thấp",
            "linguise": "Chất lượng hoàn hảo, giá cả phải chăng"
          },
          "3": {
            "google": "Phù hợp nhất cho các trang web lớn hoặc ngân sách thấp",
            "linguise": "Tốt nhất cho trang web yêu cầu chất lượng dịch thuật hoàn hảo"
          },
          "4": {
            "google": "Bối cảnh trang để dịch",
            "linguise": "Bối cảnh trang và trang web để dịch"
          }
        }
      },
      "botom_banner": {
        "title": "Trải nghiệm độ chính xác dịch thuật vô song với",
        "sub_title": "Bản dịch AI Linguise mới",
        "description": "Linguise đang nâng cấp dịch vụ dịch thuật tự động với sự ra mắt của Linguise AI Translation, một tùy chọn mới mạnh mẽ sử dụng công nghệ LLM (mô hình Llama mới nhất được tối ưu hóa cho dịch thuật) dịch thuật AI tiên tiến. Sự bổ sung này mang đến cho các nhà phát triển website và các công ty dịch thuật web chất lượng dịch thuật cao hơn, lý tưởng cho các dự án đòi hỏi sự hoàn hảo tối đa. Linguise AI Translation bổ sung cho dịch thuật Google Cloud AI chất lượng cao hiện có của chúng tôi, mang đến cho bạn sự linh hoạt và chính xác hơn."
      }
    },
    "success": {
      "tab_title": "Cảm ơn bạn đã mua gói dịch thuật AI!",
      "title": "Cảm ơn bạn đã mua gói dịch thuật AI!",
      "subtitle": "Gói dịch thuật AI của bạn đã được mua thành công!",
      "message": "Bạn có thể quản lý gói Dịch thuật AI của mình trong trang cài đặt Dịch thuật AI.",
      "home": "Quản lý bản dịch AI"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Tên",
        "description": "Tên hóa đơn"
      },
      "phone": {
        "title": "Số điện thoại",
        "description": "Số điện thoại hóa đơn"
      },
      "email": {
        "title": "Thư điện tử",
        "description": "Thư điện tử hóa đơn"
      },
      "address": {
        "title": "Địa chỉ",
        "description": "Địa chỉ hóa đơn",
        "city": "Thành phố",
        "country": "Quốc gia",
        "address1": "Địa chỉ 1",
        "address2": "Địa chỉ 2",
        "postal": "Mã bưu điện",
        "state": "Bang"
      },
      "tax": {
        "title": "Số thuế"
      }
    }
  },
  "checkouts": {
    "header": "Thanh toán",
    "payment_method": "Chọn phương thức thanh toán",
    "stripe_card": "Thẻ tín dụng (Sọc)",
    "paypal": "PayPal",
    "address": {
      "new": "Nhập địa chỉ thanh toán mới",
      "existing": "Sử dụng địa chỉ hiện có"
    },
    "pay_stripe": "Xác nhận và thanh toán",
    "terms": "Bằng cách xác nhận đăng ký của mình, bạn cho phép Linguise tính phí bạn cho các khoản thanh toán trong tương lai theo các điều khoản của chúng tôi. Bạn luôn có thể hủy đăng ký của mình.",
    "coupon": {
      "title": "Có phiếu giảm giá?",
      "placeholder": "Chèn mã phiếu giảm giá của bạn vào đây",
      "apply": "Áp dụng",
      "percent": "Giảm giá {{0}}%"
    },
    "add_new": "Thêm mới",
    "use_existing": "Sử dụng phương thức thanh toán hiện có",
    "recurring": {
      "month_single": "Thanh toán hàng tháng",
      "month_many": "Được lập hóa đơn {{count}} tháng một lần",
      "year_single": "Thanh toán hàng năm",
      "year_many": "Được lập hoá đơn {{count}} năm một lần",
      "day_single": "Thanh toán hàng ngày",
      "day_many": "Được lập hóa đơn {{count}} ngày một lần",
      "week_single": "Thanh toán hàng tuần",
      "week_many": "Được lập hóa đơn {{count}} tuần một lần"
    },
    "add_new_no_stripe": "Thêm thẻ mới",
    "summary": {
      "title": "Bản tóm tắt",
      "subtotal": "Tổng phụ",
      "total": "Tổng cộng"
    }
  },
  "dashboard": {
    "main": {
      "title": "Bảng điều khiển"
    },
    "statistics": {
      "main_title": "Thống kê trong 30 ngày qua",
      "characters": "Số ký tự được dịch",
      "words": "Số từ được dịch",
      "bandwidth": "Băng thông đầu vào",
      "request": "Yêu cầu",
      "page_views": "Lượt truy cập trang theo ngôn ngữ (30 ngày qua)",
      "multilingual_views": "Lượt truy cập trang đa ngôn ngữ (30 ngày qua)",
      "most_page_viewed": "20 trang được xem nhiều nhất (30 ngày qua)",
      "no_data_yet": "Chưa có dữ liệu",
      "th_language": "Ngôn ngữ",
      "th_page_views": "Lượt truy cập trang",
      "real_visitors": "Khách truy cập thực",
      "crawler": "Trình thu thập dữ liệu web"
    },
    "planHints": {
      "subscribeButton": "Đăng ký",
      "upgradeButton": "Nâng cấp",
      "usedWords": "Bạn hiện có {words_used} từ",
      "noPlan": "Không có gói kích hoạt cho tiên miền này. Hãy đăng ký gói và bắt đầu dịch website của bạn",
      "trialUsage": "Bạn hiện đang sử dụng {words_used} trên {words_allowed} từ được cho phép trong gói dùng thử.",
      "trialEnds": "Bản dùng thử tháng đầu tiên được kích hoạt cho đến khi {trial_ends}.",
      "subscribeMessage": "Đăng ký trước khi hết hạn để giữ cho website luôn được dịch",
      "trialReachedLimit": "Bạn đã đạt đến số từ được dịch tối đa trong thời gian dùng thử.\nĐăng ký một trong các gói của chúng tôi để tiếp tục dịch website",
      "paidUsage": "Bạn đã sử dụng {words_used} / {words_allowed} từ được dịch trong gói hiện tại",
      "paidReachedLimit": "Bạn đã đạt đến số từ được dịch tối đa trong gói hiện tại .\nNâng cấp gói của bạn để tiếp tục dịch nội dung website.",
      "trialOfferedUsage": "Bạn hiện đang sử dụng {words_used} từ trong số {words_allowed} từ có trong gói dùng thử.(Bao gồm {free_words} từ được cung cấp)",
      "paidOfferedUsage": "Bạn đã sử dụng các từ đã dịch {words_used} / {words_allowed} trong kế hoạch của mình.(Bao gồm {free_words} từ được cung cấp)",
      "noPlanExtra": "Xin lưu ý rằng các miền không hoạt động và dữ liệu của chúng sẽ tự động bị xóa thường xuyên.",
      "planRecommended": "Dựa trên khối lượng bản dịch hiện tại của bạn, kế hoạch được đề xuất là:",
      "planMaximumWords": "{{words}} từ",
      "notHaveTranslatedWords": "Bạn chưa thực hiện bất kỳ bản dịch nào",
      "noPlanShopify": "Chưa có gói nào được kích hoạt cho tên miền này. Hãy đăng ký gói trong bảng điều khiển Shopify của bạn và bắt đầu dịch trang web của bạn.",
      "subscribeMessageShopify": "Đăng ký từ bảng điều khiển Shopify của bạn trước khi hoàn tất để giữ cho trang web của bạn được dịch"
    },
    "translationSetup": {
      "kicker": "THIẾT LẬP SUBDOMAIN",
      "title": "Kiểm tra thiết lập bản dịch",
      "description": "Xem lại DNS, máy chủ đã dịch, quyền truy cập trang gốc và giới hạn tài khoản.",
      "starting": "Đang kiểm tra...",
      "button": "Kiểm tra thiết lập",
      "viewLatest": "Xem kết quả mới nhất",
      "viewCurrent": "Xem lần kiểm tra hiện tại",
      "runAgain": "Chạy lại kiểm tra",
      "viewDetails": "Xem chi tiết",
      "hideDetails": "Ẩn chi tiết",
      "error": "Không thể kiểm tra thiết lập",
      "allPassed": "Tất cả kiểm tra đều đạt",
      "setupNeedsAttention": "Thiết lập cần được chú ý",
      "setupNeedsAttentionDescription": "Một hoặc nhiều mục kiểm tra không thành công. Hãy xem các mục bên dưới hoặc liên hệ bộ phận hỗ trợ Linguise.",
      "lastChecked": "Kiểm tra lần cuối {{time}}",
      "domainOwnership": "Quyền sở hữu tên miền",
      "domainOwnershipDescription": "Đã tìm thấy bản ghi xác minh",
      "domainOwnershipFailure": "Không thể xác minh bản ghi DNS quyền sở hữu.",
      "translatedHosts": "Máy chủ đã dịch",
      "translatedHostsDescription": "Đã kiểm tra {{count}} máy chủ ngôn ngữ",
      "translatedHostsFailure": "Một hoặc nhiều bản ghi CNAME ngôn ngữ không chính xác.",
      "subdomainPage": "Trang subdomain",
      "subdomainPageDescription": "{{count}} trang đã dịch chấp nhận HTTPS",
      "subdomainPageFailure": "Kết nối TLS không thành công khi mở một hoặc nhiều trang đã dịch.",
      "originalSite": "Trang web gốc",
      "originalSiteDescription": "Kiểm tra DNS, TLS và phản hồi của trang web gốc",
      "originalSiteFailure": "Kiểm tra DNS, TLS hoặc phản hồi của trang web gốc không thành công.",
      "documentationAdvice": {
        "dns": "Xem lại thiết lập DNS",
        "tls": "Xem lại thiết lập HTTPS",
        "origin": "Xem lại thiết lập trang web gốc",
        "diagnostic": "Xem các bước khắc phục sự cố"
      },
      "evidence": {
        "originDns": "DNS gốc",
        "originTls": "TLS gốc",
        "originHttp": "Phản hồi gốc",
        "observedTargets": "Mục tiêu được phát hiện",
        "recordCount": "Bản ghi được tìm thấy",
        "addressCount": "Địa chỉ được tìm thấy",
        "statusCode": "Trạng thái HTTP",
        "redirect": "Chuyển hướng",
        "expiresAt": "Chứng chỉ hết hạn",
        "raw": "{{key}}",
        "noValue": "Không có giá trị"
      },
      "checkerError": "Không thể hoàn tất một số mục kiểm tra.",
      "coreLocation": "Đã kiểm tra từ {{location}}",
      "status": {
        "queued": "Đang xếp hàng",
        "running": "Đang chạy",
        "completed": "Đã hoàn tất",
        "failed": "Không thành công",
        "passed": "Đạt",
        "warning": "Cảnh báo",
        "unknown": "Không xác định",
        "skipped": "Đã bỏ qua",
        "not_applicable": "Không áp dụng"
      }
    },
    "throttling": {
      "title": "Giới hạn dịch thuật",
      "description": "Giới hạn sử dụng tạm thời",
      "unavailable": "Không có giới hạn dịch thuật tạm thời",
      "window": "{{used}} / {{max}} từ",
      "resetsIn": "Đặt lại sau {{time}}",
      "throttled": "Bản dịch tạm thời bị tạm dừng",
      "throttledDescription": "Đã đạt giới hạn sử dụng tạm thời. Bản dịch sẽ tiếp tục khi khoảng thời gian này được đặt lại."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "BƯỚC {{step}} TRONG {{total}}",
      "doneLabel": "XONG, BẠN CÓ THỂ BẮT ĐẦU DỊCH!",
      "finish": {
        "title": "",
        "description": "Đây là API key để bạn sử dụng trong website của bạn"
      },
      "instructions": "Hướng dẫn cài đặt",
      "domainSetting": "Thiết lập miền",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "Tập lệnh PHP",
        "wizardWordpressStep1": "1. Cài đặt ",
        "wizardWordpressStep2": "\n 2. Trong cài đặt plugin, hãy sao chép và điền vào khóa API của bạn\n",
        "wizardWordpressStep3": "3. Bạn đã sẵn sàng dịch\n\n",
        "wizardJoomlaStep4": "\n 4. Bạn đã sẵn sàng dịch\n\n",
        "wizardWordpressStep4": "Để có hướng dẫn chi tiết hơn, vui lòng xem tài liệu của chúng tôi: ",
        "wizardJoomlaStep1": "1. Liên kết gói Joomla: ",
        "wizardJoomlaStep2": "\n2. Trong cài đặt cấu hình tiện ích, hãy sao chép và điền vào khóa API của bạn",
        "wizardJoomlaStep3": "3. Trong cấu hình mô-đun, hãy đặt ngôn ngữ bạn muốn hiển thị và chèn mô-đun vào nơi bạn cần.",
        "wizardPhpStep1": "1. Tải xuống tập lệnh php của chúng tôi và tại đây ",
        "wizardPhpStep2": "\n2. Làm theo hướng dẫn cài đặt trong trang tài liệu của chúng tôi tại đây ",
        "wizardPhpStep3": "\n3. Thêm mô-đun vào các trang của bạn.",
        "wizardPhpStep4": "\n Sao chép mã sau và thêm nó vào đầu trang html của bạn, nó sẽ tự động hiển thị mô-đun trình chuyển đổi\n",
        "dispatchStep1": "Chúng tôi đã gửi thành công dữ liệu cần thiết tới plugin Linguise, bây giờ bạn có thể đóng cửa sổ sau.",
        "dispatchStep2": "Trong trường hợp mã thông báo bị mất khi bạn đóng cửa sổ này, vui lòng sao chép mã thông báo sau:",
        "dispatchStep3": "Bạn cũng có thể sao chép đoạn mã này để bật công cụ chuyển đổi cờ của chúng tôi tự động",
        "wizardOtherStep1": "Làm theo hướng dẫn bên dưới để cài đặt Linguise trên tên miền của bạn.",
        "wizardOtherStep2": "Sao chép mã sau và thêm vào đầu trang html của bạn, nó sẽ tự động hiển thị mô-đun chuyển đổi."
      },
      "trialAlreadyUsed": "Có vẻ như bạn đã sử dụng hết giới hạn của bản dùng thử miễn phí, vì vậy bạn cần phải lấy hạn ngạch dịch\nVui lòng đăng ký gói hoặc liên hệ với chúng tôi nếu bạn cần gia hạn thời gian dùng thử.",
      "usefulLinks": "Các đường dẫn hữu ích để bắt đầu",
      "linkDocumentation": "Tài liệu",
      "linkExtensionDl": "Tải extension",
      "linkSubscribe": "Đăng ký tài khoản ngay",
      "linkDashboard": "Tới bảng điều khiển",
      "exclusion": {
        "title": "Tên công ty và tên sản phẩm",
        "description": ""
      },
      "finishButton": "Hoàn thành cài đặt",
      "subdomains": "Tên miền phụ",
      "subdomain_setup": "Thiết lập tên miền",
      "subdomain_auto_setup": "Tự động kết nối DNS của bạn",
      "subdomain_manual_setup": "Tự thêm các mục DNS",
      "subdomain_skip": "Tự thêm các mục DNS",
      "auto_subdomains_info": "CMS trình tạo trang web của bạn yêu cầu cấu hình DNS để đặt ngôn ngữ cho mỗi tên miền phụ (ví dụ: vi.domain.com). Bạn có thể làm điều đó một cách tự động bằng cách sử dụng Entri. Chỉ cần nhấp vào nút \"Tự động kết nối DNS của bạn\" để bắt đầu kết nối với trình quản lý DNS của bạn và thêm chúng bằng Entri. ",
      "auto_subdomains_info_manual": "Hoặc, bạn có thể định cấu hình miền của mình theo cách thủ công bằng cách nhấp vào nút \"Tự thêm mục nhập DNS\".",
      "auto_subdomains_info_2": "Bạn có thể làm điều đó một cách tự động bằng cách sử dụng Entri. Chỉ cần nhấp vào nút \"Tự động kết nối DNS của bạn\" để bắt đầu kết nối với trình quản lý DNS của bạn và thêm chúng bằng Entri. ",
      "breadcrumbs": {
        "step1": "Bước 1: Tên miền, CMS & Ngôn ngữ",
        "step2": "Bước 2: DNS ngôn ngữ",
        "step3": "Bước {{step}}: Hướng dẫn cài đặt"
      }
    },
    "form": {
      "urls": {
        "dash": "Gạch ngang -",
        "underscore": "Gạch chân _",
        "title": "Dịch các URL",
        "description": "Bạn có muốn dịch ở tất cả các trang",
        "char_description": "Ký tự sử dụng để thay thế các ký tự không được ủy quyền trong các URL",
        "advertisement_title": "⚠ Bạn đã đặt rất nhiều ngôn ngữ.\n",
        "advertisement": "Ban đầu chúng tôi thường khuyên bạn nên bắt đầu dịch các trang web có ít ngôn ngữ. Bạn sẽ có một ý tưởng về số lượng từ trang web của bạn có.\nNó cũng tốt hơn cho SEO, vì các chương trình của Google sẽ thu thập dữ liệu tất cả các trang của bạn nhanh hơn nếu lúc đầu bạn có ít trang hơn.\nSau một tuần, bạn có thể thêm một vài ngôn ngữ khác, v.v."
      },
      "url": {
        "title": "Url",
        "description": "Thêm tên miền URL chính của bạn bắt đầu bằng http:// hoặc https://",
        "placeholder": "Tên miền URL",
        "advertisement_http": {
          "title": "Bạn không sử dụng giao thức https",
          "description": "Vui lòng kiểm tra tên miền của bạn có thực sự không sử dụng giao thức https, giao thức mà ngày nay được khuyến nghị dùng."
        },
        "advertisement_www": {
          "title": "Tên miền phụ của bạn không phải là www",
          "description": "Phần lớn thời gian tên miền phụ mặc định là www (như https://www.mydomain.com). Đây có thể không phải là trường hợp của bạn nhưng vui lòng kiểm tra kỹ xem tên miền bạn muốn thêm có chính xác không."
        },
        "invalid_url": {
          "line1": "Chúng tôi không thể tìm thấy tên miền của bạn. Vui lòng kiểm tra xem tên miền của bạn có thể truy cập công khai qua Internet và nó không bị chuyển hướng đến vị trí khác hay không. ",
          "line2": "Nếu bạn chắc chắn rằng tên miền của mình có thể truy cập được, bạn có thể bỏ qua xác minh tên miền và nhấn lại nút \"Bước tiếp theo\"",
          "contact": "Trong mọi trường hợp bạn có thể liên hệ với chúng tôi tại",
          "force": "Bỏ qua xác minh tên miền"
        },
        "invalid_subdomain_url": "URL này không được phép. Tên miền phụ phải có dạng: https://www.domain.tld hoặc https://domain.tld không có thư mục con."
      },
      "account": {
        "title": "Tài khoản",
        "description": "Chọn một tài khoản để chỉ định miền này",
        "placeholder": "Chọn tài khoản...",
        "feedback": "Bạn phải chọn một tài khoản"
      },
      "platform": {
        "title": "Nền tảng",
        "description": "Vui lòng chọn nền tảng trang web của bạn theo tên CMS.",
        "learn": "Tìm hiểu cách chọn nó",
        "placeholder": "Nền tảng tìm kiếm theo tên CMS...",
        "info": {
          "title": "⚠ Nền tảng này đã được thêm vào gần đây.\n",
          "desc": "Nền tảng xây dựng trang web này được Linguise hỗ trợ, mặc dù nó mới được thêm vào gần đây. Nếu bạn gặp bất kỳ vấn đề nào, vui lòng liên hệ với chúng tôi bằng email hỗ trợ trực tiếp:"
        },
        "description_read_only": "Nền tảng trang web của bạn đang sử dụng",
        "feedback": "Bạn phải chọn một nền tảng"
      },
      "language": {
        "title": "Ngôn ngữ",
        "description": "Chọn ngôn ngữ gốc cho website của bạn",
        "placeholder": "Chọn ngôn ngữ...",
        "feedback": "Bạn phải chọn một ngôn ngữ",
        "description_read_only": "Ngôn ngữ gốc cho website của bạn"
      },
      "token": {
        "title": "Khóa API",
        "description": "Đây là API Key để bạn sao chép vào website của bạn",
        "copy": "Sao chép vào clipboard",
        "reset": "Tạo lại API Key",
        "reset_confirm": "Vui lòng xác nhận việc tạo lại API Key"
      },
      "languages": {
        "title": "Dịch ngôn ngữ",
        "description": "Chọn các ngôn ngữ bạn muốn dịch cho website của mình",
        "placeholder": "Chọn ngôn ngữ...",
        "feedback": "Bạn phải chọn một ngôn ngữ"
      },
      "defaultRules": {
        "title": "Các quy tắc mặc định",
        "description": "Chúng tôi đã xác định một tập hợp các quy tắc phải sử dụng để tăng cường bản dịch và tránh nội dung không mong muốn được dịch, như bảng điều khiển WordPress.\nBạn có thể xóa hoặc chỉnh sửa các quy tắc của luận án sau nếu muốn."
      },
      "disallow_deletion": "Aktív előfizetéssel rendelkező tartományt nem lehet törölni",
      "delete_confirm": "Vui lòng xác nhận việc xóa tên miền",
      "delete": "Xóa tên miền",
      "dynamic": {
        "title": "Dịch nội dung động",
        "description": "Nội dung động được tạo bởi yêu cầu JavaScript và AJAX sẽ được dịch (Tùy chọn này sẽ tăng mức độ sử dụng bản dịch của bạn)"
      },
      "partial_translations": {
        "title": "Cho phép dịch một phần",
        "description": "Nếu tài khoản của bạn đã đạt hạn ngạch dịch nhưng trang vẫn yêu cầu dịch, Linguise có thể tiếp tục hiển thị trang có nội dung đã được dịch. Tuy nhiên, một số phần của trang sẽ vẫn chưa được dịch cho đến khi bạn nâng cấp hạn ngạch của mình. Mặc dù một lượng nhỏ nội dung chưa được dịch thường không gây hại cho SEO nhưng việc cho phép quá nhiều nội dung chưa được dịch có thể tác động tiêu cực đến trải nghiệm người dùng. Để giải quyết vấn đề này, bạn có thể đặt ngưỡng cho phần trăm nội dung chưa được dịch được phép trên một trang. Nếu nội dung chưa được dịch vượt quá ngưỡng này, người dùng sẽ tự động được chuyển hướng về phiên bản ngôn ngữ gốc của trang.",
        "never": "Không bao giờ"
      },
      "translate_error_pages": {
        "title": "Dịch các trang lỗi",
        "description": "Linguise có thể dịch tất cả các trang lỗi, tuy nhiên nếu trang lỗi của bạn chứa nội dung động, như địa chỉ IP hoặc ID yêu cầu, bạn nên tránh dịch các trang này.",
        "not_found_page": {
          "title": "Dịch trang 404"
        },
        "error_page": {
          "title": "Dịch các trang lỗi khác"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Đã tìm thấy tên miền hiện có",
          "description": "Một tên miền hiện có đã được tìm thấy cho người dùng này, bạn có muốn sử dụng nó không?"
        }
      },
      "search_tl": {
        "title": "Tìm kiếm bản dịch",
        "description": "Bật tìm kiếm bản dịch cho nền tảng trang web của bạn (Thử nghiệm, tùy chọn này sẽ tăng lượng sử dụng bản dịch của bạn)"
      },
      "shopify_promo": {
        "info": "Tin vui! Giờ đây chúng tôi đã có ứng dụng Shopify gốc mà bạn có thể cài đặt từ Shopify App Store.",
        "hyperlink": "Nhấp vào đây và tiến hành cài đặt Linguise từ ứng dụng.",
        "next_btn": "Hãy truy cập cửa hàng Shopify để cài đặt ứng dụng.",
        "info_legacy": "Tin vui! Giờ đây chúng tôi đã có ứng dụng Shopify gốc mà bạn có thể cài đặt từ Shopify App Store.",
        "description_legacy": "Hãy chọn nền tảng \"Shopify\" thay vì \"Shopify Legacy\"."
      },
      "wix_promo": {
        "info": "Tin vui! Giờ đây chúng tôi đã có ứng dụng Wix gốc mà bạn có thể cài đặt từ Wix App Market.",
        "hyperlink": "Nhấp vào đây và tiến hành cài đặt Linguise từ ứng dụng.",
        "next_btn": "Hãy truy cập Wix App Market để cài đặt ứng dụng.",
        "info_legacy": "Tin vui! Giờ đây chúng tôi đã có ứng dụng Wix gốc mà bạn có thể cài đặt từ Wix App Market.",
        "description_legacy": "Hãy chọn nền tảng \"Wix\" thay vì \"Wix Legacy\"."
      },
      "ai_disallow_deletion": "Bạn không thể xóa tên miền này khi vẫn còn hạn mức AI. Vui lòng liên hệ với nhóm hỗ trợ của chúng tôi nếu bạn muốn xóa tên miền này.",
      "language_removal": {
        "card": {
          "title": "Xóa bản dịch của các ngôn ngữ đã gỡ",
          "description": "Các ngôn ngữ này đã được gỡ khỏi trang web, nhưng bản dịch đã lưu vẫn được tính vào hạn mức. Hãy xóa chúng để nhận lại số từ.",
          "button": "Xóa bản dịch"
        },
        "hint": "Số từ đã dùng sẽ được hoàn lại vào hạn mức. Bạn có thể thực hiện một lần mỗi {{days}} ngày cho từng trang web.",
        "modal": {
          "title": "Xóa bản dịch?",
          "intro": "Các bản dịch này sẽ bị xóa vĩnh viễn:",
          "warning": "Không thể hoàn tác thao tác này. Số từ đã dùng sẽ được hoàn lại vào hạn mức và có thể mất vài phút.",
          "limit": "Bạn có thể thực hiện một lần mỗi {{days}} ngày cho từng trang web.",
          "confirm": "Xóa bản dịch"
        },
        "scheduled": "Đang xóa bản dịch và hạn mức của bạn sẽ sớm được cập nhật.",
        "cooldown": "Bản dịch của trang web này vừa được xóa gần đây. Bạn có thể xóa lại vào {{date}}.",
        "latest_completed": {
          "title": "Lần xóa gần nhất đã hoàn tất",
          "description": "Xem các ngôn ngữ đã xóa và số từ được hoàn lại vào hạn mức.",
          "languages": "Ngôn ngữ đã xóa",
          "words_returned": "Số từ được hoàn lại vào hạn mức: {{words}}",
          "completed_at": "Hoàn tất lúc {{date}}"
        },
        "status": {
          "recent_title": "Lần xóa bản dịch gần đây",
          "recent_description": "Theo dõi lần xóa gần nhất và xem khi nào có thể thực hiện lần tiếp theo.",
          "progress_title": "Tiến trình xóa",
          "loading": "Đang kiểm tra tiến trình xóa...",
          "unavailable": "Không thể tải tiến trình xóa. Hãy làm mới trang và thử lại.",
          "label": "Trạng thái",
          "pending": "Đang chờ",
          "processing": "Đang xử lý",
          "completed": "Đã hoàn tất",
          "failed": "Thất bại",
          "unknown": "Không có trạng thái",
          "percent": "{{percent}}% hoàn tất",
          "current_stage": "Bước hiện tại: {{stage}}",
          "processed": "Đã xử lý {{processed}} bản ghi",
          "processed_total": "Đã xử lý {{processed}} trên {{total}} bản ghi",
          "requested_at": "Được yêu cầu lúc {{date}}",
          "started_at": "Bắt đầu lúc {{date}}",
          "completed_at": "Hoàn tất lúc {{date}}",
          "cooldown_period": "Bạn có thể thực hiện một lần mỗi {{days}} ngày cho từng trang web.",
          "cooldown_blocked": "Chưa thể bắt đầu một lần xóa khác.",
          "stage": {
            "queued": "Đang chờ bắt đầu",
            "processing": "Đang xử lý",
            "refund_summary": "Đang tính số từ được hoàn lại",
            "search_translations": "Đang xóa bản dịch tìm kiếm",
            "url_translations": "Đang xóa bản dịch URL",
            "translations": "Đang xóa bản dịch",
            "completed": "Đã hoàn tất",
            "failed": "Thất bại",
            "unknown": "Đang xử lý"
          }
        },
        "forbidden": "Bạn không có quyền xóa bản dịch."
      }
    },
    "main": {
      "edit": "Sửa tên miền",
      "add": "Thêm tên miền",
      "wizard": "Chào mừng! Tiến trình tạo tên miền mới",
      "common": "Lãnh địa"
    },
    "subdomains": {
      "config_ok": "Tên miền phụ DNS đã được cấu hình đúng.",
      "config_invalid": "DNS tên miền phụ yêu cầu một số cấu hình bổ sung để hoạt động.",
      "config_check": "Cấu hình DNS tên miền phụ đang được kiểm tra, vui lòng đợi...",
      "entri_timeout": "Entri đã báo cáo rằng quá trình truyền bá DNS tên miền phụ của bạn đã hết thời gian chờ, bạn cần phải thử lại hoặc bạn có thể thực hiện theo cách thủ công.",
      "entri_process": "DNS của bạn đã được thêm Entri và thường mất 10-30 phút để phổ biến (áp dụng tất cả các tên miền phụ ngôn ngữ của bạn như vi.domain.com). Nếu quá trình xác thực DNS chưa hoàn tất sau 24 giờ, bạn có thể liên hệ với nhóm hỗ trợ của chúng tôi: support@linguise.com ",
      "entri_ok": "Việc phổ biến DNS đang diễn ra! Đang chờ tuyên truyền... ",
      "infos": "Bạn cần thêm các mục nhập DNS này vào bản ghi DNS tên miền của mình để kích hoạt quá trình dịch. Nhấp vào nút kiểm tra khi đã hoàn tất. Quá trình cập nhật bản ghi DNS có thể mất một chút thời gian, vì vậy bạn có thể cần quay lại sau vài phút hoặc vài giờ.",
      "check": "Kiểm tra cấu hình DNS"
    },
    "notice": {
      "broken_card": "Chúng tôi không thể gia hạn gói {{url}} của bạn bằng phương thức thanh toán hiện tại, vui lòng cập nhật thẻ thanh toán của bạn",
      "quota_reached": "Hạn ngạch dịch của bạn cho {{url}} đã đạt đến, vui lòng nâng cấp để tiếp tục dịch trang web của bạn",
      "important": "Quan trọng",
      "quota_reached_button": "Nâng cấp gói của bạn ngay bây giờ",
      "broken_card_button": "Cập nhật thẻ thanh toán của bạn",
      "ai_no_subscription": "Bản dịch AI cho {{url}} yêu cầu đăng ký hoặc dùng thử đang hoạt động. Tính năng này sẽ dừng nếu không có đăng ký hoặc dùng thử, vui lòng nâng cấp để tiếp tục.",
      "ai_no_subscription_button": "Nâng cấp gói cước của bạn ngay bây giờ",
      "quota_warning": "Hạn mức dịch của bạn cho {{url}} đã đạt {{throttling_used_percent}}%, hạn mức này sẽ được đặt lại sau {{ttl}}",
      "locked": "Miền {{url}} hiện bị khóa di chuyển, bạn vẫn có thể truy cập trang web của mình nhưng không thể chỉnh sửa hoặc thêm bản dịch mới!"
    },
    "subscription": {
      "next_payment_amount": "Các khoản phí sắp tới",
      "next_payment_date": "Ngày thanh toán tiếp theo",
      "invoice": {
        "header": "Lịch sử hóa đơn",
        "date": "Ngày",
        "amount_due": "Số lượng",
        "status": "Trạng thái",
        "actions": "hành động",
        "description": "Khi các giao dịch có sẵn, bạn có thể xem chúng ở đây.",
        "status_text": {
          "draft": "Bản nháp",
          "open": "Chưa giải quyết",
          "paid": "Trả",
          "uncollectible": "Không thể sưu tập",
          "void": "Vô hiệu",
          "failed": "Thất bại",
          "retrying": "Thử lại"
        },
        "view": "Xem",
        "empty": "Không có hóa đơn gần đây được tìm thấy cho đăng ký này",
        "retry_payment": "Thử lại"
      },
      "next_cancellation": "Ngày hủy",
      "cancel": "Hủy đăng ký",
      "change_plan": "Thay đổi kế hoạch",
      "change": "Thay đổi",
      "suspend": "Tạm dừng thanh toán",
      "resume": "Tiếp tục đăng ký",
      "back": "Mặt sau",
      "save": "Cứu",
      "confirm_resume": "Bạn có chắc chắn muốn tiếp tục đăng ký này không?",
      "confirm_cancel": "Bạn có chắc chắn muốn hủy đăng ký này không?",
      "confirm_header": "Bạn có chắc không?",
      "missing_status": "Đăng ký này bị thiếu",
      "not_found": "Không tìm thấy gói đăng ký cho tên miền này",
      "no_payment_method": "Không rõ",
      "remove_billing": "Di dời",
      "confirm_manual_retry": "Bạn có chắc chắn muốn thử lại khoản thanh toán này không?",
      "shopify_maneged": "Đăng ký này được quản lý bởi Shopify. Vui lòng quản lý từ bảng quản trị Shopify của bạn.",
      "unknown_plan": "Gói không xác định"
    }
  },
  "domain_listing": {
    "select": "Chọn tên miền",
    "add": "Thêm website"
  },
  "editable": {
    "number": "số {{id}}"
  },
  "footer": {
    "about": "Về chúng tôi",
    "support": "Hỗ trợ"
  },
  "frontendEditor": {
    "main": "Soạn thảo trực tiếp",
    "description": "Soạn thảo trực tiếp giúp bạn điều chỉnh tức thì các bản dịch trên website",
    "button": "Mở soạn thảo trực tiếp",
    "language_selection": "Lựa chọn ngôn ngữ dịch",
    "video_label": "Tìm hiểu cách sử dụng trình chỉnh sửa trực tiếp"
  },
  "general": {
    "403": {
      "tab_title": "Ooops - Lỗi 403",
      "title": "Quyền truy cập bị từ chối",
      "message": "Có vẻ như bạn không có quyền truy cập vào trang được yêu cầu.",
      "home": "Trở về nhà"
    },
    "404": {
      "tab_title": "Ooops - Lỗi 404",
      "title": "Không tìm thấy trang",
      "message": "Có vẻ như bạn đi sai hướng. Đừng lo lắng... nó thường xảy đến với chúng ta. Đây là mẹo nhỏ giúp bạn quay lại đúng đường.",
      "home": "Quay về trang chủ"
    },
    "500": {
      "tab_title": "Lỗi 500",
      "title": "Lỗi hệ thống máy chủ nội bộ",
      "message": "Tại sao bạn không thử tải lại trang? hoặc liên lạc với chúng tôi",
      "home": "Quay về trang chủ"
    },
    "fields": {
      "alert": "Một số trường không hợp lệ, vui lòng sữa các trường không hợp lệ",
      "invalid": "Thông tin không hợp lệ",
      "phone_re": "Số điện thoại không hợp lệ",
      "phone_invalid": "Số điện thoại không hợp lệ",
      "email": "Trường email không hợp lệ"
    },
    "saving": "Đang lưu ...",
    "save": "Lưu",
    "save_and_quit": "Lưu & Thoát",
    "invite": "Mời",
    "cancel": "Hủy",
    "yes": "Có",
    "no": "Không",
    "nextStep": "Bước tiếp theo",
    "loading": "Vui lòng chờ trong khi ứng dụng tải",
    "goback": "Quay trở lại",
    "manage": "Quản lý",
    "delete": "Xóa",
    "deleting": "Đang xóa ...",
    "table": {
      "no_data": "Chưa có dữ liệu nào ở đây..."
    },
    "confirm": "Xác nhận",
    "unknown": "Không xác định",
    "hide": "Trốn",
    "show": "Trình diễn",
    "on": "TRÊN",
    "off": "Tắt",
    "default": "Mặc định"
  },
  "home": {
    "header": "Trang Chủ",
    "manage": "Quản lý thuê bao",
    "activate_now": "Kích hoạt ngay",
    "activate_plan_now": "Theo dõi ngay",
    "upgrade_plan_now": "Nâng cấp gói ngay bây giờ",
    "trial_message_part_1": "Bạn hiện đang sử dụng gói dùng thử, ",
    "trial_message_part_2": "Bạn hiện đang sử dụng gói dùng thử, ",
    "add": "Thêm miền ",
    "table": {
      "title": "Miền",
      "description": "Danh sách tên miền của bạn, click vào tên miền để quản lý bản dịch"
    },
    "domains": {
      "empty": "Bạn không có bất kỳ miền nào tại tài khoản này"
    },
    "accountsList": {
      "title": "Tài khoản",
      "add": "Thêm tài khoản mới",
      "name": "Tên tài khoản"
    },
    "update_credit_card": "Cập nhật chi tiết thẻ tín dụng",
    "canceled": "Đã hủy đăng ký",
    "cancelling_subs": "Đang hủy lúc {{0}}",
    "resume_subscription": "Tiếp tục đăng ký",
    "shopify_managed": "Được quản lý bởi Shopify",
    "trial_ends_at": "Kết thúc lúc {{0}}",
    "free_trial": "Dùng thử miễn phí",
    "no_subs": "Không có đăng ký hoạt động"
  },
  "invoices": {
    "title": "Hóa đơn",
    "list": {
      "title": "Danh sách hóa đơn"
    },
    "table": {
      "customer": "Khách hàng",
      "domain": "Tên miền",
      "amountPaid": "Số tiền đã trả",
      "status": "Trạng thái",
      "date": "Ngày",
      "invoice": "Hóa đơn",
      "pay": "Thanh toán hóa đơn",
      "actions": "hành động",
      "deleted_domain": "Đã xóa tên miền",
      "plan_name": "Kế hoạch",
      "action": "Hoạt động"
    },
    "listPending": {
      "title": "Danh sách hóa đơn chờ xử lý"
    }
  },
  "language_settings": {
    "display": "Hiển thị danh sách ngôn ngữ",
    "position": "Chức vụ",
    "display_help_text": "Hiển thị cờ và/hoặc tên ngôn ngữ. Vị trí mặc định của trình chuyển đổi ngôn ngữ có thể ở bất kỳ đâu trong nội dung hoặc ở một vị trí cố định cố định hoặc di chuyển khi cuộn",
    "side_by_side": "Cạnh bên nhau",
    "dropdown": "thả xuống",
    "popup": "Cửa sổ bật lên",
    "flag": "Lá cờ",
    "lang_name": "Tên ngôn ngữ",
    "lang_short_name": "Tên ngắn gọn",
    "positions": {
      "in_place": "tại chỗ",
      "top_left": "Trên cùng bên trái",
      "top_left_no_scroll": "Trên cùng bên trái (không cuộn)",
      "top_right": "Trên cùng bên phải",
      "top_right_no_scroll": "Trên cùng bên phải (không cuộn)",
      "bottom_left": "Dưới cùng bên trái",
      "bottom_left_no_scroll": "Dưới cùng bên trái (không cuộn)",
      "bottom_right": "Góc phải ở phía dưới",
      "bottom_right_no_scroll": "Dưới cùng bên phải (không cuộn)"
    },
    "lang_names_display": {
      "title": "Hiển thị tên ngôn ngữ",
      "help_text": "Trong trình chuyển đổi ngôn ngữ, hiển thị tên ngôn ngữ bằng tiếng Anh hoặc bằng ngôn ngữ gốc, tức là tiếng Pháp hoặc tiếng Pháp",
      "english": "Tiếng Anh",
      "native_languages": "Bản ngữ"
    },
    "flag_shape": {
      "title": "kiểu cờ",
      "help_text": "Sử dụng các biểu tượng cờ svg hình tròn hoặc hình chữ nhật",
      "round": "Tròn",
      "rectangular": "Hình hộp chữ nhật"
    },
    "english_flag_type": {
      "title": "loại cờ tiếng anh",
      "help_text": "Sử dụng Cờ Vương quốc Anh hoặc Hoa Kỳ cho tiếng Anh",
      "usa": "USA cờ",
      "great_britain": "cờ Vương quốc Anh"
    },
    "german_flag_type": {
      "title": "loại cờ Đức",
      "help_text": "Sử dụng Cờ Áo hoặc Đức cho tiếng Đức",
      "german": "lá cờ Đức",
      "austria": "cờ Áo"
    },
    "spain_flag_type": {
      "title": "loại cờ Tây Ban Nha",
      "help_text": "Sử dụng Cờ Mexico hoặc Tây Ban Nha cho tiếng Tây Ban Nha",
      "spanish": "Cờ Tây Ban Nha",
      "mexico": "Cờ Mexico",
      "peruvian": "Cờ Peru"
    },
    "portugal_flag_type": {
      "title": "loại cờ Bồ Đào Nha",
      "help_text": "Sử dụng Cờ Bồ Đào Nha hoặc Brazil cho tiếng Bồ Đào Nha",
      "portugal": "Cờ Bồ Đào Nha",
      "brazil": "Cờ Brazil"
    },
    "taiwanese_flag_type": {
      "title": "Loại cờ Đài Loan",
      "help_text": "Sử dụng cờ Đài Loan hoặc Trung Quốc cho người Đài Loan",
      "taiwanese": "Cờ Đài Loan",
      "chinese": "Cờ Trung Quốc"
    },
    "flag_border_radius": {
      "title": "Bán kính đường viền cờ (px)",
      "help_text": "Nếu đang sử dụng hình dạng cờ hình chữ nhật, bạn có thể áp dụng bán kính đường viền tùy chỉnh theo pixel"
    },
    "flag_width": {
      "title": "Kích thước cờ (px)",
      "help_text": "Chọn kích thước cờ tính bằng pixel. Điều đó không làm thay đổi trọng lượng hình ảnh vì đây là định dạng .svg"
    },
    "lang_color": {
      "color_title": "Màu tên ngôn ngữ",
      "color_help_text": "Chọn màu văn bản mặc định cho tên ngôn ngữ của bạn",
      "hover_color_title": "Màu di chuột tên ngôn ngữ",
      "hover_color_help_text": "Chọn màu văn bản di chuột cho tên ngôn ngữ của bạn",
      "color_popup_title": "Màu ngôn ngữ bật lên",
      "color_popup_help_text": "Màu của tiêu đề ngôn ngữ trong cửa sổ bật lên hoặc trong khu vực thả xuống",
      "hover_color_popup_title": "Màu di chuột của ngôn ngữ bật lên",
      "hover_color_popup_help_text": "Chọn màu văn bản di chuột của tiêu đề ngôn ngữ trong cửa sổ bật lên hoặc trong khu vực thả xuống"
    },
    "flag_box_shadow": {
      "shadow_title": "Bóng hộp cờ",
      "shadow_help_text": "Kích thước màu và bóng cho cờ ngôn ngữ của bạn",
      "hover_shadow_title": "Bóng hộp gắn cờ khi di chuột",
      "hover_shadow_help_text": "Kích thước màu và bóng cho các cờ ngôn ngữ của bạn khi di chuột",
      "shadow_h_offset": "Độ lệch bóng H (px)",
      "shadow_v_offset": "Độ lệch bóng V (px)",
      "shadow_blur": "Bóng mờ (px)",
      "shadow_spread": "Trải rộng bóng tối (px)",
      "shadow_color": "Màu bóng"
    },
    "order": "Thứ tự ngôn ngữ",
    "language_order_help": "Thứ tự của ngôn ngữ sẽ được hiển thị trong trình chuyển đổi ngôn ngữ. Bạn có thể kéo và thả ngôn ngữ để sắp xếp lại chúng. ",
    "order_reset": "Đặt lại thứ tự",
    "language_order_dragdrop": "Bạn có thể kéo và thả ngôn ngữ để sắp xếp lại chúng.",
    "popup_lang_name": "Tên ngôn ngữ bật lên",
    "preview": "Xem trước ngôn ngữ"
  },
  "link": {
    "form": {
      "original": {
        "title": "Nguồn chính thức",
        "description": "Thêm URL liên kết ban đầu của bạn và thay thế nó bên dưới bằng ngôn ngữ để dịch chúng",
        "srcset_description": "Bạn đang chỉnh sửa url hình ảnh. Vui lòng đảm bảo đọc tài liệu, đặc biệt nếu bạn sử dụng srcset hoặc không biết nó là gì",
        "link": "liên kết",
        "match_link": "Chế độ trận đấu",
        "match_exact": "Chính xác",
        "match_wildcard": "Ký tự đại diện",
        "match_regex": "Biểu thức chính quy"
      },
      "alternative_languages": {
        "title": "Liên kết để thay thế",
        "description": "Thay thế các liên kết phương tiện và liên kết bên ngoài trên tất cả các trang của bạn, theo ngôn ngữ…",
        "link": "Liên kết để thay thế"
      },
      "error": {
        "atLeastOne": "Vui lòng thêm ít nhất một bản dịch.",
        "url": "Url không hợp lệ",
        "extension": "Liên kết phải có phần mở rộng nhưng không được là .html hoặc .php. Và liên kết không được chứa bất kỳ đường dẫn ngôn ngữ nào, ví dụ: \"/fr\"",
        "regex": "Biểu thức chính quy không hợp lệ",
        "wildcard": "Liên kết đại diện có giao thức không hợp lệ"
      }
    },
    "main": {
      "parent": "liên kết",
      "edit": "chỉnh sửa liên kết"
    }
  },
  "links": {
    "title": "Quản lý phương tiện truyền thông và liên kết bên ngoài",
    "description": "Liệt kê và chỉnh sửa trang web của bạn Liên kết phương tiện hoặc liên kết bên ngoài.",
    "add": "Thêm liên kết",
    "delete": "Xóa liên kết",
    "table": {
      "original": "Nguyên bản",
      "language": "Ngôn ngữ",
      "translation": "Dịch",
      "action": "Hoạt động",
      "delete_confirm": "Vui lòng xác nhận xóa liên kết"
    }
  },
  "members": {
    "header": "Các thành viên",
    "invite": "Mời thành viên mới",
    "modal": {
      "inviteHeader": "Mời thành viên mới",
      "editHeader": "Chỉnh sửa thành viên",
      "detachHeader": "Tách thành viên",
      "detachBody": "Bạn có chắc chắn muốn tách thành viên khỏi tài khoản này không?",
      "selfDetachBody": "Bạn có chắc chắn muốn tách mình khỏi việc quản lý tài khoản này không? Sau đó, bạn sẽ không thể truy cập bất kỳ dữ liệu nào liên quan đến tài khoản này. "
    },
    "table": {
      "title": "Danh sách thành viên",
      "description": "Vai trò của thành viên và quyền truy cập tên miền",
      "name": "Tên",
      "email": "Email",
      "websites": "Trang web",
      "languages": "Ngôn ngữ",
      "role": "Vai trò",
      "status": "Trạng thái",
      "resendInvite": "gửi lại",
      "inviteSent": "lời mời đã được gửi",
      "actions": "hành động",
      "edit": "Biên tập",
      "detach": "tách ra",
      "empty": "Bạn chưa có thành viên nào",
      "all_website": "Tất cả trang web và ngôn ngữ",
      "roles": {
        "admin": "Quản trị viên",
        "manager": "Quản lý",
        "translator": "Người dịch"
      },
      "statuses": {
        "pending": "Đang chờ",
        "accepted": "Đã chấp nhận",
        "declined": "Đã từ chối"
      }
    },
    "errors": {
      "role": "Bạn phải chọn một vai trò",
      "domains": "Bạn phải chọn ít nhất 1 trang web cho vai trò đã chọn",
      "languages": "Bạn phải chọn ít nhất 1 ngôn ngữ cho các trang web đã chọn"
    },
    "inviteSent": "Lời mời của bạn đã được gửi thành công"
  },
  "pagination": {
    "showing": "Hiển thị {{limit}} trên {{total}} kết quả",
    "showing_only_count": "Hiển thị {{limit}} kết quả"
  },
  "payments_method": {
    "header": "Phương thức thanh toán",
    "table": {
      "title": "Danh sách phương thức thanh toán",
      "description": "Phương thức thanh toán được đính kèm vào tài khoản của bạn",
      "default": "Mặc định",
      "action_edit_remove": "Chỉnh sửa hoặc xóa",
      "action_remove": "Di dời",
      "action_default": "Đặt làm mặc định",
      "action_fallback": "Đặt làm dự phòng",
      "expires": "Hết hạn",
      "add_new_card": "Thêm phương thức thanh toán",
      "action_fallback_remove": "Xóa khỏi dự phòng",
      "fallback": "Dự phòng",
      "action_edit": "Biên tập",
      "action_delete": "Xóa bỏ",
      "action_default_remove": "Xóa làm mặc định",
      "domain_count@@one": "Được sử dụng bởi các miền {{count}}",
      "domain_count@@other": "Được sử dụng bởi {{count}} tên miền"
    },
    "paypal_bind": {
      "button": "Kết nối tài khoản PayPal",
      "button_load": "Đang kết nối...",
      "disconnected": "Không được kết nối",
      "error": "Đã xảy ra lỗi",
      "success_header": "Thành công",
      "success_no_promo": "Tài khoản PayPal của bạn hiện đã được kết nối",
      "success": "Tài khoản PayPal của bạn hiện đã được kết nối, $5 sẽ được khấu trừ từ hóa đơn tiếp theo của bạn!"
    },
    "card_add": {
      "header": "Thêm thẻ mới",
      "success": "Đã kết nối thẻ mới với Linguise!",
      "terms": "Bằng cách cung cấp thông tin thẻ của mình, bạn cho phép Linguise tính phí thẻ của bạn cho các khoản thanh toán trong tương lai theo điều khoản dịch vụ của chúng tôi."
    },
    "card_detail": {
      "header": "Thông tin thẻ",
      "delete": {
        "error": "Bạn không thể xóa phương thức thanh toán này vì nó có đăng ký đang hoạt động!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Đăng ký theo phương thức thanh toán này",
        "header_domain": "Lãnh địa",
        "header_plan": "Kế hoạch",
        "header_status": "Trạng thái",
        "header_actions": "hành động",
        "cancelling": "Đang hủy lúc: {{0}}",
        "next_payment": "Thanh toán tiếp theo vào lúc: {{0}}",
        "action_renew": "Gia hạn",
        "no_subs_header": "Không có đăng ký nào để hiển thị",
        "no_subs_desc": "Sau khi đăng ký thẻ này, mọi thông tin sẽ được hiển thị tại đây",
        "action_manage": "Quản lý"
      },
      "status": {
        "active": "Tích cực",
        "canceled": "Đã hủy",
        "incomplete": "Chưa thanh toán",
        "incomplete_expired": "Chưa thanh toán (Đã hết hạn)",
        "past_due": "Quá hạn",
        "trialing": "Sự thử nghiệm",
        "unpaid": "Chưa thanh toán",
        "missing": "Lỗi"
      }
    },
    "delete_confirm_body": "Bạn có chắc chắn muốn xóa phương thức thanh toán này không? Hành động này không thể đảo ngược!",
    "delete_confirm_header": "Xóa phương thức thanh toán?",
    "card_edit": {
      "header": "Chỉnh sửa thẻ",
      "billing_header": "Thông tin thanh toán",
      "address_error": "Địa chỉ là bắt buộc!",
      "card_number": "Số thẻ",
      "card_expiry": "Ngày hết hạn",
      "expiry_error_month": "Tháng được cung cấp không hợp lệ",
      "expiry_error_year": "Năm được cung cấp không hợp lệ",
      "expiry_error_expired": "Năm hết hạn thẻ của bạn đã qua.",
      "card_header": "Thông tin thẻ",
      "expiry_error_empty": "Trường này là bắt buộc!"
    }
  },
  "plans": {
    "per": "một",
    "wordsTranslated": "từ được dịch",
    "current": "Hiện tại",
    "archived": "Đã lưu trữ",
    "day": "ngày",
    "week": "tuần",
    "month": "tháng",
    "year": "năm",
    "activate": "Hoạt động",
    "cancel": "Hủy",
    "change": "Thay đổi",
    "upgrade": "Nâng cấp",
    "downgrade": "Hạ cấp",
    "notEnoughWords": "Không đủ từ",
    "yearIntervalOnly": "Không thể chuyển sang gói năm",
    "wordsUnlimited": "Không giới hạn từ",
    "tabs": {
      "day": "Giá theo ngày",
      "week": "Giá theo tuần",
      "month": "Giá theo tháng",
      "year": "Giá theo năm",
      "sub_texts": {
        "day": "Một mức giá cố định mỗi ngày",
        "week": "Một mức giá cố định, mỗi tuần",
        "month": "Một mức giá cố định mỗi tháng",
        "year": "Miễn phí một tháng, một hóa đơn mỗi năm"
      }
    },
    "details": {
      "new_languages": "Thêm ngôn ngữ mới bất cứ lúc nào",
      "one_month_trial": "Dùng thử miễn phí một tháng cho mọi trang web mới",
      "multi_content_indexed": "100% nội dung đa ngôn ngữ được lập chỉ mục",
      "translate_new_content": "Dịch nội dung mới ngay lập tức",
      "free_installation": "Cài đặt và thiết lập miễn phí",
      "compared_monthly_plan": "Miễn phí một tháng so với gói hàng tháng",
      "risk_free_recurring": "Lỗi thanh toán định kỳ không có rủi ro",
      "unlimited_languages": "Không giới hạn ngôn ngữ và lượt xem trang",
      "high_server_resources": "Tài nguyên máy chủ cao",
      "billed": {
        "day": "Thanh toán hàng ngày",
        "week": "Thanh toán hàng tuần",
        "month": "Thanh toán hàng tháng",
        "year": "Thanh toán hàng năm"
      },
      "request_max_size": "Kích thước yêu cầu tối đa {{0}}"
    },
    "frequent_question": {
      "title": "Câu hỏi thường gặp",
      "questions": {
        "trial": {
          "question": "Tôi có thể sử dụng bản dùng thử trên tên miền trang web mới không?",
          "answer": "Có, chúng tôi cung cấp bản dùng thử miễn phí 30 ngày cho mỗi miền trang web mới mà bạn thêm vào tài khoản của mình. Bằng cách này, bạn có thể kiểm tra đầy đủ dịch vụ dịch thuật trên trang web mới của mình."
        },
        "seo": {
          "question": "Mất bao lâu để SEO của tôi cải thiện?",
          "answer": "Nội dung và nội dung đa ngôn ngữ cần có thời gian để được lập chỉ mục đầy đủ và được xếp hạng tốt. Tùy thuộc vào lưu lượng truy cập và quy mô trang web của bạn, thời gian sẽ từ 3 đến 6 tuần."
        },
        "quota": {
          "question": "Bản dịch của con người có được bao gồm trong hạn ngạch không?",
          "answer": "Không, giới hạn số từ chỉ dành cho bản dịch máy tự động. Người dịch có thể chỉnh sửa bản dịch tự động theo cách thủ công mà không có giới hạn."
        }
      }
    },
    "best_offer": "Phục vụ tốt nhất",
    "resume": "Bản tóm tắt",
    "subsCanceled": "Có một lần hủy đăng ký khác đang diễn ra",
    "period": {
      "days@@one": "ngày",
      "days@@other": "{{count}} ngày",
      "hours@@one": "giờ",
      "hours@@other": "{{count}} giờ",
      "minutes@@one": "phút",
      "minutes@@other": "{{count}} phút",
      "seconds@@one": "thứ hai",
      "seconds@@other": "{{count}} giây"
    },
    "words": {
      "billion": "{{value}} tỷ",
      "million": "{{value}} triệu",
      "thousand": "{{value}} nghìn"
    },
    "throttling_info": "{{words}} từ mỗi {{period}}"
  },
  "profile": {
    "welcome": "Chào mừng!",
    "account": "Tài khoản của tôi",
    "subscriptions": "Gói đăng ký",
    "logout": "Thoát"
  },
  "register": {
    "errors": {
      "password": "Tối thiểu 8 ký tự, bất kỳ ký tự nào"
    }
  },
  "route": {
    "dashboard": "Bảng điều khiển",
    "rules": "Các quy tắc",
    "translations": "Các bản dịch",
    "search_translations": "Tìm kiếm bản dịch",
    "urls_translations": "Dịch các Url",
    "links": "Phương tiện truyền thông và liên kết bên ngoài",
    "online_editor": "Soạn thảo trực tiếp",
    "settings": "Cài đặt",
    "domain": {
      "finish": "Cài đặt",
      "preconfig": "Cài đặt"
    },
    "home": "Trang chủ",
    "domain_list": "Danh sách tên miền",
    "members": "Các thành viên",
    "invoices": "Hóa đơn",
    "billing": "Chi tiết thanh toán",
    "language_display": "Hiển thị cờ ngôn ngữ",
    "payment_methods": "Phương thức thanh toán",
    "ai_translation": "Bản dịch AI",
    "ai_translation_settings": "Cài đặt",
    "ai_translation_pricing": "Giá cả"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Văn bản bỏ qua",
        "add": "Thêm mới",
        "title": "Văn bản bỏ qua",
        "description": "Thêm một hoặc nhiều văn bản bỏ qua",
        "ignore_case": "Trường hợp bỏ qua"
      },
      "html_content": {
        "title": "Áp dụng cho nội dung html",
        "description": "Áp dụng tất cả quy tắc lên nội dung của bạn hoặc lấy một bộ chọn CSS cụ thể",
        "all_page": "Tất cả các trang",
        "css_selector": "Bộ chọn CSS",
        "label": "Bộ chọn CSS",
        "placeholder": "Bộ chọn để áp dụng",
        "add": "Thêm mới"
      },
      "apply_to_urls": {
        "title": "Áp dụng cho các URL",
        "description": "Chọn URL cụ thể nơi bạn muốn quy tắc được áp dụng",
        "all_urls": "Tất cả các URL",
        "selected_urls": "Các URL đã chọn",
        "label": "Url để áp dụng",
        "placeholder": "Url để áp dụng",
        "original_url": "Các URL gốc",
        "translated_url": "URL đã dịch",
        "wildcard": "Ký tự đại diện",
        "regex": "Biểu thức chính quy Regex",
        "add": "Thêm mới",
        "expression": "Loại biểu thức"
      },
      "apply_urls": {
        "title_exclude": "Loại trừ các URL",
        "title_replace": "Thay thế các URL",
        "title_description": "Cũng áp dụng quy tắc này để dịch các URL"
      },
      "apply_languages": {
        "title": "Áp dụng cho ngôn ngữ",
        "description": "Chọn ngôn ngữ cụ thể nơi bạn muốn quy tắc được áp dụng",
        "all_languages": "Tất cả ngôn ngữ",
        "selected_languages": "Các ngôn ngữ đã chọn",
        "placeholder": "Chọn nhiều ngôn ngữ...",
        "feedback": "Bạn phải chọn một ngôn ngữ"
      },
      "name": {
        "title": "Tiêu đề",
        "description": "Cung cấp cho quy tắc một tiêu đề",
        "placeholder": "Tên quy tắc"
      },
      "type": {
        "title": "Loại",
        "description": "Chọn loại quy tắc bạn muốn thêm",
        "text_ignore": "Văn bản bỏ qua",
        "text_replace": "Văn bản thay thế",
        "content_exclusion": "Nội dung loại trừ",
        "url_exclusion": "Loại trừ dịch Url",
        "ignore_inline": "Bỏ qua nội tuyến",
        "full_description": {
          "text_ignore": "Thêm quy tắc để tránh một số văn bản được dịch. Nó có thể là tên sản phẩm, tên thương hiệu hoặc các yếu tố kỹ thuật khác mà bạn không muốn dịch.",
          "text_replace": "Thay thế văn bản cho phép thay thế một số văn bản bằng bản dịch bạn muốn, nó cần thiết khi bản dịch bỏ qua ngữ cảnh.",
          "content_exclusion": "Loại trừ nội dung sẽ giúp bạn tránh dịch một số nội dung trên trang .\n  Nếu bạn muốn loại trừ hoàn toàn một trang khỏi bản dịch (không đa ngôn ngữ cho trang này và không dịch nội dung) hãy sử dụng mẫu \"Loại trừ dịch Url\"",
          "url_exclusion": "Loại trừ dịch trang sẽ giúp bạn đặt các trang bạn không muốn dịch",
          "ignore_inline": "Tránh dịch một số nội dung dưới dạng nội dung nội tuyến, thay vào đó hãy dịch từng thẻ riêng biệt."
        }
      },
      "text_replace": {
        "title": "Văn bản thay thế",
        "description": "Thay thế một số văn bản trong bản dịch cụ thể. Thay thế bất kỳ văn bản nào trên tất cả các trang của bạn.",
        "text_to_replace": "Văn bản thay thế",
        "ignore_case": "Trường hợp bỏ qua",
        "text_type": "Thay thể khi dịch",
        "text_type_original": "Gốc",
        "text_type_translation": "Dịch",
        "keep_case": "Giữ nguyên trường hợp này",
        "add": "Thêm mới"
      },
      "content_exclusion": {
        "title": "Nội dung loại trừ",
        "description": "Chọn một hoặc nhiều bộ chọn CSS sẽ được dịch",
        "label": "Bộ chọn CSS",
        "placeholder": "Bộ chọn để áp dụng",
        "add": "Thêm mới"
      },
      "multilingual_url": {
        "title": "Sử dụng URL đa ngôn ngữ",
        "description": "Nếu chọn có, URL sẽ KHÔNG được dịch nhưng trang sẽ vẫn hiển thị đa ngôn ngữ với nội dung được dịch",
        "live_example_title": "Ví dụ thực tế",
        "live_example_description": "URL nguồn: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "URL được tạo: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "URL được tạo: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Áp dụng quy tắc trên nội dung tĩnh hoặc nội dung động hoặc cả hai",
        "title": "Áp dụng cho nội dung",
        "all": "Tất cả nội dung",
        "static": "Nội dung tĩnh",
        "dynamic": "Nội dung động"
      },
      "force_apply_urls": {
        "title_description": "Lực lượng áp dụng quy tắc này cho tất cả các bản dịch của URL, bao gồm các bản dịch hiện có!",
        "title_replace": "Lực thay thế trong URLS",
        "title_exclude": "Lực lượng loại trừ trong URL",
        "warning": "Cảnh báo",
        "warning_part1": "Đặt cái này thành \"Có\" có thể phá vỡ các bản dịch URL trang web của bạn.",
        "warning_part2": "Điều này có thể tạo ra một trang 404S tạm thời hoặc vĩnh viễn, vui lòng chỉ tiếp tục nếu bạn hiểu hậu quả.",
        "warning_replacement_original": "Cảnh báo bổ sung: Bạn đang cố gắng thay thế nội dung gốc có thể ảnh hưởng đến URL, bản dịch có thể thất bại vì ngôn ngữ không thể tìm thấy URL gốc đúng cách"
      }
    },
    "main": {
      "parent": "Các quy tắc",
      "edit": "Sửa quy tắc",
      "add": "Thêm quy tắc mới"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" sẽ được loại trừ trong nội dung và URL",
      "preview_single": "\"{{text_ignore}}\" sẽ được loại trừ trong nội dung",
      "preview_more_with_url": "\"{{text_ignore}}\" và {{count}} nữa sẽ được loại trừ trong nội dung",
      "preview_more": "\"{{text_ignore}}\" và {{count}}sẽ được loại trừ trong nội dung",
      "other_parameters": "Một vài lựa chọn khác khi cài đặt quy tắc này, nhấn vào nút chỉnh sửa để biết thêm thông tin"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" được thay thế bởi \"{{replacement}}\" trong nội dung và các URL",
      "preview_single": "\"{{original}}\" được thay thế bởi \"{{replacement}}\" trong nội dung",
      "preview_more_with_url": "\"{{original}}\" được thay thế bởi \"{{replacement}}\" trong nội dung và các URL, và {{nb}} nữa",
      "preview_more": "\"{{original}}\" được thay thế bởi \"{{replacement}}\" trong nội dung, và {{nb}} nữa",
      "other_parameters": "Một vài lựa chọn khác khi cài đặt quy tắc này, nhấn vào nút chỉnh sửa để biết thêm thông tin"
    },
    "content_exclusion": {
      "selectors": "{{nb}} Bộ chọn CSS loại trừ khi dịch",
      "other_parameters": "Một vài lựa chọn khác khi cài đặt quy tắc này, nhấn vào nút chỉnh sửa để biết thêm thông tin"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL được loại trừ khi dịch, nhưng vẫn giữ tiền tố đa ngôn ngữ",
      "some": "{{nb}} URL được loại trừ hoàn toàn khi dịch",
      "all_multilingual": "tất cả URL được loại trừ khi dịch, nhưng vẫn giữ tiền tố đa ngôn ngữ",
      "all": "tất cả URL được loại trừ hoàn toàn khi dịch",
      "other_parameters": "Một vài lựa chọn khác khi cài đặt quy tắc này, nhấn vào nút chỉnh sửa để biết thêm thông tin"
    },
    "ignore_inline": {
      "elements": "Tất cả nội dung nội tuyến sẽ được dịch thành nội dung khối trong trang",
      "all_elements": "Một số nội dung nội dòng sẽ được dịch thành nội dung khối trong trang",
      "other_parameters": "Các tham số khác đã được thiết lập cho quy tắc này, hãy nhấp vào nút chỉnh sửa để xem thêm thông tin."
    },
    "title": "Quản lý các quy tắc",
    "description": "Quản lý nội dung dịch loại trừ và thay thế tất cả trên website",
    "add": "Thêm quy tắc mới",
    "table": {
      "title": "Tiêu đề",
      "type": "Loại",
      "preview": "Xem trước quy tắc",
      "action": "Hoạt động",
      "delete_confirm": "Vui lòng xác nhận việc xóa quy tắc",
      "types": {
        "text_ignore": "Văn bản bỏ qua",
        "text_replace": "Văn bản thay thế",
        "content_exclusion": "Loại trừ nội dung",
        "url_exclusion": "Loại trừ url",
        "ignore_inline": "Bỏ qua nội tuyến",
        "unknown": "Quy tắc không xác định"
      },
      "no_data": "Chưa có quy tắc nào ở đây"
    },
    "apply_on_content": {
      "static": "Quy tắc này chỉ áp dụng cho nội dung tĩnh.",
      "dynamic": "Quy tắc này chỉ được áp dụng cho nội dung động."
    }
  },
  "search_translations": {
    "title": "Quản lý bản dịch tìm kiếm",
    "description": "Liệt kê tất cả bản dịch trang web của bạn được sử dụng thông qua các biểu mẫu tìm kiếm (Từ ngôn ngữ đã dịch sang ngôn ngữ cơ sở miền của bạn)",
    "filter_languages": "Lọc theo các ngôn ngữ ...",
    "filter_original": "Lọc theo văn bản gốc",
    "filter_translation": "Lọc theo văn bản đã dịch",
    "table": {
      "original": "Bản gốc",
      "language": "Ngôn ngữ",
      "translation": "Bản dịch"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Đăng ký không thành công!",
      "title": "Đăng ký không thành công!",
      "subtitle": "Đã xảy ra lỗi khi cố gắng xử lý đăng ký của bạn.",
      "home": "Trở về nhà",
      "generic": "Đã xảy ra lỗi không xác định ở phía Linguise, vui lòng liên hệ với quản trị viên!"
    },
    "success": {
      "home": "Quản lý bản dịch tên miền",
      "message": "Chúng tôi cam kết mang đến cho bạn trải nghiệm dịch thuật tốt nhất có thể. Đội ngũ chuyên gia của chúng tôi sẵn sàng hỗ trợ bạn với bất kỳ câu hỏi hoặc hỗ trợ nào bạn có thể cần. Để bắt đầu, chỉ cần nhấp vào nút bên dưới.",
      "subtitle": "Cảm ơn bạn đã lựa chọn dịch vụ dịch thuật Linguise",
      "title": "Đăng ký đã được kích hoạt!",
      "tab_title": "Cảm ơn bạn đã đăng ký!"
    }
  },
  "subscriptions": {
    "edit": {
      "title": "Quản lý đăng ký"
    },
    "list": {
      "title": "Danh sách đăng ký",
      "description": "Danh sách tên miền đăng ký của bạn"
    },
    "table": {
      "domain": "Tên miền",
      "plan": "Gói đăng ký",
      "status": "Trạng thái",
      "card": "Thẻ",
      "usage": "Sử dụng",
      "actions": "Hoạt động",
      "payment_method": "Phương thức thanh toán"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} từ",
      "paidOffered": "{{words_used}} / {{words_allowed}} từ\n(Bao gồm {{free_words}} từ được cung cấp)"
    },
    "success": {
      "tab_title": "Đăng ký đã được kích hoạt!",
      "title": "Đăng ký đã được kích hoạt!",
      "subtitle": "Cảm ơn bạn đã lựa chọn dịch vụ dịch thuật Linguise",
      "message": "'Chúng tôi cam kết cung cấp cho bạn trải nghiệm dịch thuật tốt nhất có thể. Đội ngũ chuyên gia của chúng tôi sẵn sàng hỗ trợ bạn với bất kỳ câu hỏi hoặc hỗ trợ nào bạn có thể cần. Để bắt đầu, chỉ cần nhấp vào nút bên dưới.",
      "home": "Quản lý bản dịch tên miền"
    },
    "popup": {
      "dueToday": "Tổng số tiền phải trả hôm nay",
      "nextPeriod": "Bắt đầu từ {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Chọn một tài khoản"
    }
  },
  "translation": {
    "main": {
      "parent": "Các bản dịch",
      "edit": "Sửa bản dịch"
    },
    "form": {
      "original": {
        "title": "Bản gốc trong {{language}}"
      },
      "is_inline": "Bản dịch này được tạo từ nội dung nội tuyến.",
      "inline_editor": {
        "count_warning": "Số vùng nội tuyến không khớp với bản gốc ({{current}} trên {{expected}}).",
        "restore_original": "Khôi phục văn bản gốc",
        "insert_placeholder": "Chèn phần giữ chỗ",
        "drag": "Kéo để sắp xếp lại vùng nội tuyến",
        "area": "Vùng nội tuyến {{index}}",
        "restore": "Khôi phục các vùng nội tuyến bị thiếu"
      },
      "translation": {
        "title": "Bản dịch bằng {{language}}",
        "description": "Bản dịch bạn muốn ghi đè"
      }
    },
    "copy": {
      "title": "Sao chép vào bản dịch thủ công",
      "label": "Sao chép vào thủ công"
    },
    "level": {
      "base": {
        "title": "Bản dịch cơ sở",
        "subtitle": "Tự động · bản dịch Linguise Cloud",
        "empty": "Chưa có bản dịch cơ sở cho văn bản này.",
        "overridden": "Lựa chọn của bạn đã được lưu, nhưng bản dịch AI nâng cao mới nhất được hiển thị thay thế vì “Ghi đè bản dịch thủ công và bản dịch đã chọn” đang là Có trong cài đặt Dịch AI. Hãy tắt cài đặt này để dùng lựa chọn của bạn."
      },
      "not_generated": "Chưa tạo",
      "none": "Chưa có",
      "ai": {
        "title": "Bản dịch AI nâng cao",
        "subtitle": "Tự động · Linguise AI",
        "empty_title": "Chưa tạo cho văn bản này",
        "empty_description": "Linguise AI cho bản dịch tự nhiên hơn nhờ ngữ cảnh của trang và website của bạn. Để có bản dịch này ở đây:",
        "empty_step_1": "Vào Dịch AI › Cài đặt và đặt Bật dịch AI thành “Chỉ có quy tắc”, “Chỉ biên tập trực tiếp” hoặc “Quy tắc và biên tập viên trực tiếp”.",
        "empty_step_2": "Áp dụng bằng một Quy tắc khớp với trang này, hoặc bật theo từng trang từ trình biên tập trực tiếp.",
        "empty_step_3": "Bản dịch AI nâng cao sẽ xuất hiện ở đây sau khi được tạo. Việc này sử dụng tín chỉ AI của bạn.",
        "open_settings": "Mở cài đặt Dịch AI",
        "open_editor": "Mở trình biên tập trực tiếp",
        "overrides_selection": "Lựa chọn của bạn đã được lưu, nhưng bản dịch AI nâng cao này được hiển thị thay thế vì “Ghi đè bản dịch thủ công và bản dịch đã chọn” đang là Có trong cài đặt Dịch AI. Hãy tắt cài đặt này để dùng lựa chọn của bạn.",
        "overrides_version": "Phiên bản bạn đã chọn đã được lưu, nhưng phiên bản AI nâng cao mới nhất được hiển thị thay thế vì “Ghi đè bản dịch thủ công và bản dịch đã chọn” đang là Có trong cài đặt Dịch AI. Hãy tắt cài đặt này để dùng phiên bản đã chọn."
      },
      "manual": {
        "title": "Bản dịch thủ công",
        "subtitle": "Do bạn viết · ưu tiên hơn bản dịch tự động",
        "empty": "Trống",
        "saved_but_overridden": "Đã lưu theo lựa chọn của bạn, nhưng không tự động hiển thị vì “Ghi đè bản dịch thủ công” đang là Có trong cài đặt Dịch AI: bản dịch AI nâng cao được ưu tiên cho đến khi tắt cài đặt này.",
        "ignored": "Không tự động hiển thị vì “Ghi đè bản dịch thủ công” đang là Có trong cài đặt Dịch AI. Hãy chọn nó để dùng cho văn bản này.",
        "label": "Bản dịch của bạn",
        "placeholder": "Nhập bản dịch của riêng bạn...",
        "last_updated": "Sửa lần cuối {{date}}",
        "save_hint": "Lưu bản dịch thủ công sẽ kích hoạt bản dịch đó.",
        "delete": "Xóa bản dịch thủ công",
        "delete_confirm": "Vui lòng xác nhận xóa bản dịch thủ công"
      }
    },
    "history": {
      "title": "Các phiên bản AI nâng cao",
      "subtitle": "Mọi lần tạo lại từ trình biên tập trực tiếp đều được lưu",
      "unknown_model": "Mô hình không xác định",
      "current": "Hiện tại",
      "restore": "Khôi phục phiên bản này",
      "restore_note": "Khôi phục sẽ biến phiên bản đó thành bản dịch AI nâng cao hiện tại. Không có gì bị xóa.",
      "version_of": "Phiên bản {{current}} / {{total}}",
      "hide": "Ẩn lịch sử ({{total}})",
      "show": "Hiện lịch sử ({{total}})"
    },
    "choose": {
      "title": "Bản dịch {{language}} · chọn bản khách truy cập sẽ thấy",
      "current": "Hiện đang dùng trên website:",
      "priority": "Thứ tự ưu tiên mặc định: Thủ công › AI nâng cao › Cơ sở. Lựa chọn của bạn chỉ được lưu cho bản dịch này.",
      "reset": "Đặt lại về thứ tự ưu tiên mặc định",
      "reset_title": "Bỏ lựa chọn của bạn cho văn bản này và dùng lại thứ tự ưu tiên mặc định",
      "resetting": "Đang đặt lại ..."
    }
  },
  "translations": {
    "title": "Quản lý các bản dịch",
    "description": "Liệt kê tất cả các bản dịch website của bạn, để dịch trực quan sử dụng soạn thảo trực tiếp",
    "filter_languages": "Lọc theo các ngôn ngữ ...",
    "filter_original": "Lọc theo văn bản gốc",
    "filter_translation": "Lọc theo văn bản đã dịch",
    "table": {
      "original": "Bản gốc",
      "language": "Ngôn ngữ",
      "action": "Hoạt động",
      "base": "Cơ sở",
      "ai": "AI nâng cao",
      "manual": "Thủ công"
    },
    "filter_exact": "Trận đấu chính xác",
    "badge": {
      "active": "Đang dùng",
      "overrides_manual": "Ghi đè thủ công"
    },
    "cell": {
      "none": "không có",
      "not_generated": "chưa tạo",
      "ignored": "Bị bỏ qua – quy tắc AI thắng"
    },
    "tabs": {
      "all": "Tất cả",
      "manual": "Có thủ công",
      "ai": "Có AI nâng cao",
      "base": "Chỉ cơ sở"
    },
    "levels_hint": "Mỗi văn bản có tối đa 3 cấp — cấp được đánh dấu Đang dùng là bản khách truy cập thấy."
  },
  "url": {
    "main": {
      "parent": "URLs",
      "edit": "Chỉnh sửa bản dịch URL"
    },
    "form": {
      "original": {
        "title": "Bản gốc trong {{language}}"
      },
      "translation": {
        "title": "Bản dịch URL sang {{language}}",
        "description": "URL bạn muốn ghi đè",
        "placeholder": "Ghi đè bản dịch Url",
        "invalid_full": "Bạn đang cố gắng thay đổi với định dạng không chính xác, bạn chỉ nên thay đổi slugs/pathname của bản dịch URL",
        "invalid": "URL/đường dẫn được cung cấp không hợp lệ"
      }
    }
  },
  "urls": {
    "title": "Quản lý các URL",
    "description": "Liệt kê và chỉnh sửa toàn bộ nội dung URL được dịch của website (nâng cao, cẩn thận với lỗi 404)",
    "filter_languages": "Lọc theo các ngôn ngữ ...",
    "filter_original": "Lọc theo văn bản gốc",
    "filter_translation": "Lọc theo văn bản đã dịch",
    "table": {
      "original": "Gốc",
      "language": "Ngôn ngữ",
      "url": "URL đã dịch",
      "action": "Hành động",
      "edited": "Bản dịch gốc đã được chỉnh sửa"
    }
  }
}
